<template>
	<v-dialog
		v-model="showDialog"
		max-width="800"
	>
		<v-card>
			<v-container grid-list-xl>
				<CategoryForm
					:existing-categories="categoryNames"
					:archived-categories="archivedNames"
					@new="$emit('close-new')"
				>
					<v-btn
						slot="buttons"
						flat
						color="error"
						@click="close()"
					>
						close
					</v-btn>
				</CategoryForm>
			</v-container>
		</v-card>
	</v-dialog>
</template>

<script>
import CategoryForm from '@/components/Report/CategoryForm';

export default {
	components: {
		CategoryForm,
	},
	props: {
		show: { type: Boolean, default: false },
	},
	data() {
		return {
			showDialog: false,
		};
	},
	computed: {
		archivedNames() {
			return this.$store.get('categoriesArchived').map(o => o.name);
		},
		categoryNames() {
			return this.$store.get('categories').map(o => o.name);
		},
	},
	watch: {
		show: {
			handler(val) {
				this.showDialog = val;
			},
			immediate: true,
		},
		showDialog(val) {
			if (!val) {
				this.close();
			}
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style>

</style>
